import styled from "styled-components"

type StyledProps = {
  $blockingState: boolean
}

export const CustomStateComponent = styled.div<StyledProps>`
  border-radius: 0.6rem;
  background: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorBackground : theme.colors.yellowLight};
  color: ${({ theme, $blockingState }) =>
    $blockingState ? theme.colors.errorText : theme.colors.orange};
  font-weight: 700;
  border: 0.1rem solid
    ${({ theme, $blockingState }) =>
      $blockingState ? theme.colors.errorBorder : theme.colors.yellow};
  font-size: 1rem;
  display: flex;
  justify-content: center;
  padding: 0 0.5rem;
  line-height: 2rem;
  text-align: center;
`

export const RecentState = styled.div`
  width: 100%;
  cursor: pointer;
`

export const CustomStateInfo = styled.div`
  padding: 0 0.8rem;
  justify-content: center;
  display: flex;
  align-items: center;
  line-height: 2.3rem;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`

export const CustomStateWrapper = styled.div`
  display: flex;
`
export const Operation = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 1rem;
    margin-right: 0.5rem;
    fill: ${({ theme }) => theme.colors.errorText};
  }
`
export const Id = styled.div`
  font-size: 1.1rem;
`

export const State = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0.1rem solid ${p => p.theme.colors.borderLight};
  background: ${p => p.theme.colors.white};
  border-radius: 0.6rem;
  padding: 1rem;
  margin-bottom: 1rem;
`
